<div id="managecsp" class="subBlockContainer managesubscriptiondetails">
  <child-header [title]="details?.customer?.out_company_name" (closeEvent)="close()"></child-header>
  <div #ParentWrapper class="subBlockContent">
    <div class="title-wrapper">
      <img class="page-title-img" [src]="details?.annuityType?.logo">
    </div>
    <div class="item-title-wrapper">
      <mat-accordion multi>
        <!-- End User Details -->
        <mat-expansion-panel [expanded]="panelEndUserDetailsOpen">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">END USER DETAILS</mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text">NAME:&nbsp;</span><span>{{ details?.customer?.out_company_name }}</span>
              <span class="highlight-text">| TENANT ID:&nbsp;</span><span>{{ details?.customer?.out_tenant_id }}</span>
              <span class="highlight-text">| STATUS:&nbsp;</span><span>{{ details?.customer?.out_status_desc }}</span>
              <mat-spinner *ngIf="isSubscriptionResponseLoading" diameter="20" mode="indeterminate" 
                class="circle cSPCustomerEntitlements-loading"></mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <dd-csp-end-user-details [details]="details" [isSubscriptionResponseLoading]="isSubscriptionResponseLoading"
            [subscriptionResponse]="subscriptionResponse"></dd-csp-end-user-details>
        </mat-expansion-panel>

        <!-- Tenant Management -->
        <mat-expansion-panel [expanded]="panelTenantManagementOpen"
          (opened)="panelTenantManagementOpen = true; cspTenantManagement.openTab()"
          (closed)="panelTenantManagementOpen = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">TENANT MANAGEMENT</mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text" href="/" (click)="reportClick()">Reporting Dashboard</span>
              <span>&nbsp;&nbsp;|&nbsp;&nbsp;<img src="../images/new_ui/azurePortal.png" alt="{{headerLink?.name}}">&nbsp;</span>
              <a class="linkheader" (click)="headerLinkClick($event)" href="{{headerLink?.link}}" target="_blank">{{headerLink?.name}}</a>
              <mat-spinner *ngIf="isTenantManagementLoading" mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading" diameter="20"></mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <dd-csp-tenant-managements #cspTenantManagement (headerLink)="headerLink=$event"
            [(loadingState)]="isTenantManagementLoading"></dd-csp-tenant-managements>
        </mat-expansion-panel>

        <!-- End User Portal Management -->
        <mat-expansion-panel [expanded]="panelEndUserPortalManagementOpen">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">
              END USER PORTAL MANAGEMENT
            </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <mat-spinner *ngIf="isTenantManagementLoading" mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading" diameter="20">
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <dd-csp-end-user-portal-management>
          </dd-csp-end-user-portal-management>
        </mat-expansion-panel>

        <!-- NCE Subscription -->
        <mat-expansion-panel [expanded]="panelNCESubscriptionOpen">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">
              NCE SUBSCRIPTION
            </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text">{{ nceSubs?.length ? nceSubs.length : "0" }} Subscription(s)</span>
              <mat-spinner *ngIf="isCSPItemLoading" mode="indeterminate" class="circle cSPCustomerEntitlements-loading"
                diameter="20">
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <!-- <dd-csp-license-subscription></dd-csp-license-subscription> -->
          <div style="font-size: 12px;">
            <div class="panel-body">
              <div *ngIf="(nceSubs?.length || annuityItemsPendingList?.length) && !isCSPItemLoading">
                <h6 class="red-text nce-migration-indicator" *ngIf="details?.customer.out_status == 'SY'">
                  Subscription refresh in progress
                </h6>
                <h6 class="red-text nce-migration-indicator" *ngIf="cSPDetailsItemViewModel?.nceCreationPedning">
                  NCE subscription creation in progress
                </h6>
                <h6 *ngIf="annuity?.migrationInProgress" class="red-text nce-migration-indicator">
                  NCE Migration In Progress
                </h6>

                <div class="row filter-wrapper">
                  <div class="col-md-3">
                    <div class="searchInputGroup">
                      <div class="searchIcon">
                        <img src="../images/new_ui/filter.png">
                      </div>
                      <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"  onblur="this.placeholder='Filter'"
                       [(ngModel)]="searchSubscription" (ngModelChange)="onMatChange()" #input>
                    </div>
                  </div>
                  <div class="col-md-3 listpart select-out-wrapper">
                    <ng-select class="customDropdwon" [multiple]="true" [items]="statusList" bindValue="value"
                      bindLabel="name" placeholder="Status" [(ngModel)]="selectedStatus" (change)="filterNCETableByStatus()">
                      <ng-template ng-header-tmp>
                        <div>
                          <button class="btn btn-link" (click)="onSelectAll()">Select All</button>
                          <button class="btn btn-link" (click)="onClearAll()">Clear All</button>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>

                  <div class="col-md-3 listpart select-out-wrapper">
                    <ng-select class="customDropdwon" [items]="renewalOptionsList" bindValue="value"
                      bindLabel="name" placeholder="Renewal Options" [(ngModel)]="selectedRenewalOptions" (change)="filterNCETableByRenewalOptions()">
                    </ng-select>
                  </div>

                  <div class="migrate-all-button">
                    <div>
                      <button *ngIf="showAzurePlan && isMCASigned"
                        class="button button-red button-large auzre-plan-width"
                        (click)="checkAzureUpgradeEligibility(upgradeAzureContainer, $event)"
                        [disabled]="!subscriptionResponse || subscriptionResponse?.status == 'Fail'">
                        Upgrade to Azure Plan
                      </button>
                      <mat-spinner *ngIf="showAzureButtonUpgradeloading" mode="indeterminate"
                        class="circle upgrade-azure-plan-loading" diameter="20">
                      </mat-spinner>
                    </div>
                    <!-- <div colspan="4" *ngIf="showAzureButtonUpgradeloading" class="azure-loading">
                      <mat-spinner mode="indeterminate" class="circle" diameter="20"></mat-spinner>
                    </div> -->
                    <div *ngIf="isAzureUpgradeInProgress"
                      class="basic-icon information-icon azureplan-information-icon"></div>
                    <label *ngIf="isAzureUpgradeInProgress">Azure Plan Upgrade In Progress</label>
                    <div *ngIf="hasPendingAzureProduct"
                      class="basic-icon information-icon azureplan-information-icon"></div>
                    <label *ngIf="hasPendingAzureProduct">All Azure subscriptions must be active for azure plan
                      migration</label>
                  </div>
                </div>

                <table mat-table [dataSource]="nceSubsDataSource" matSort (matSortChange)="nceSubTableSortChange($event)" 
                    matSortDisableClear multiTemplateDataRows>

                  <!-- Description Column -->
                  <ng-container matColumnDef="desc">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="desc" style="width: 35%;">
                      DESCRIPTION
                    </th>
                    <td mat-cell *matCellDef="let subscription" class="push-left-75" style="width: 10%;">
                      <span [attr.rowspan]="pendingRenewalCheck(subscription?.baseSubscription?.out_status_desc)" class="description">
                        {{subscription?.baseSubscription?.out_sub_description}}
                      </span>
                      <div class="result-info">
                        <mat-spinner *ngIf="showMpnIdloading" style="float: right;" mode="indeterminate"
                          class="circle" diameter="20">
                        </mat-spinner>
                        <div class="produc-secondary-title-wrapper">
                          <span class="red-bold">{{subscription?.baseSubscription?.out_stock_code}}</span>
                        </div>
                      </div>
                      <div>
                        <span class="description">{{subscription?.baseSubscription?.out_stk_description}}</span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Qty Column -->
                  <ng-container matColumnDef="qty">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="qty" style="width: 5%;" class="align-center">
                      QTY
                    </th>
                    <td mat-cell *matCellDef="let subscription" class="align-center">
                      {{subscription?.baseSubscription?.out_qty}}
                    </td>
                  </ng-container>

                  <!-- Price Column -->
                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: right;">
                      PRICE
                    </th>
                    <td mat-cell *matCellDef="let subscription" class="align-right">
                      <div>
                        <span>{{convertPriceByTermAndBF(subscription?.baseSubscription?.out_stock_code, subscription?.baseSubscription?.out_price) |
                          currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                        <span *ngIf="subscription?.baseSubscription?.out_billing_freq == '1'">/mth</span>
                        <span *ngIf="subscription?.baseSubscription?.out_billing_freq == 'Y'">/yr</span>
                      </div>
                      <div>
                        <span>{{convertPriceByTermAndBF(subscription?.baseSubscription?.out_stock_code, subscription?.baseSubscription?.out_amount) |
                          currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                        <span *ngIf="subscription?.baseSubscription?.out_billing_freq == '1'">/mth</span>
                        <span *ngIf="subscription?.baseSubscription?.out_billing_freq == 'Y'">/yr</span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- RRP Column -->
                  <ng-container matColumnDef="rrp">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: right;">
                      RRP
                    </th>
                    <td mat-cell *matCellDef="let subscription" class="align-right">
                      <div>
                        <span>{{convertPriceByTermAndBF(subscription?.baseSubscription?.out_stock_code, subscription?.baseSubscription?.out_rrp) |
                          currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                        <span *ngIf="subscription?.baseSubscription?.out_billing_freq == '1'">/mth</span>
                        <span *ngIf="subscription?.baseSubscription?.out_billing_freq == 'Y'">/yr</span>
                      </div>
                      <div>
                        <span>{{ getRRPTotal(subscription) | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                        <span *ngIf="subscription?.baseSubscription?.out_billing_freq == '1'">/mth</span>
                        <span *ngIf="subscription?.baseSubscription?.out_billing_freq == 'Y'">/yr</span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Auto Renewal Column -->
                  <ng-container matColumnDef="autoRenewal">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="autoRenewal" class="align-center" style="width: 10%;"
                      >
                      AUTO RENEWAL
                    </th>
                    <td mat-cell *matCellDef="let subscription" class="align-center">
                      <div>
                        <img *ngIf="subscription?.baseSubscription?.out_auto_renew == 'true'" src="../../images/site-icons/yes.svg" style="width: 17px; height: 16px;">
                        <img *ngIf="subscription?.baseSubscription?.out_auto_renew == 'false'" src="../../images/site-icons/no.svg" style="width: 17px; height: 16px;">
                      
                        <span class="produc-secondary-title-wrapper"
                          *ngIf="getScheduledChange(subscription.baseSubscription.out_subscription_id)">
                          <a style="cursor: pointer;" placement="bottom" [ngbTooltip]="ScheduleChangesUpdate"
                            #t2="ngbTooltip">
                            <span class="small-logo-wrapper">
                              <img style="margin-left: 5px; width: 16px; height: 16px;" src="../images/new_ui/clock-red.svg">
                            </span>
                          </a>
                        </span>
                        <ng-template #ScheduleChangesUpdate>
                          <div class="d-flex flex-column" style="text-align: left;">
                            <span>Scheduled Changes for next renewal</span>
                            <br />
                            <span>Quantity: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.quantity }}</span>
                            <span>SKU: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.stockCode.toUpperCase() }}</span>
                            <span *ngIf="getScheduledChange(subscription.baseSubscription.out_subscription_id)?.billingCycle">Billing cycle: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.billingCycle }}</span>
                            <span>Term: {{ cs.getTermDisplay(getScheduledChange(subscription.baseSubscription.out_subscription_id)?.term) }}</span>
                            <span *ngIf="getScheduledChange(subscription.baseSubscription.out_subscription_id)?.customTermEndDate">End Date Alignment: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.customTermEndDate |  date: 'dd/MM/yyyy' }}</span>
                          </div>
                        </ng-template>
                      </div>

                      <div>
                        <span>{{subscription?.baseSubscription?.out_expiry_date}}</span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Status Column -->
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status" class="align-center" style="width: 5%;"
                      >
                      STATUS
                    </th>
                    <td mat-cell *matCellDef="let subscription" class="align-center">
                      <ng-container *ngIf="!getPendingMessage(subscription?.baseSubscription).changeAmount">
                        <span>
                          {{subscription?.baseSubscription?.out_status_desc}}
                        </span>
                        <mat-spinner
                          *ngIf="subscription?.baseSubscription?.cancelingLoading && !subscription?.baseSubscription?.cancelingNceSub"
                          style="margin: auto;" mode="indeterminate" class="circle" diameter="20">
                        </mat-spinner>
                      </ng-container>
                      <ng-container *ngIf="getPendingMessage(subscription?.baseSubscription).changeAmount">
                        <span class="pending-vendor-confirmation display-inline-block">
                          {{getPendingMessage(subscription?.baseSubscription)?.out_status_desc}}
                        </span>
                        <br />
                        <mat-icon class="usernameicon" placement="bottom"
                          ngbTooltip="{{getPendingMessage(subscription?.baseSubscription)?.out_message}}"
                          tooltipClass="ngbTooltip">
                          info
                        </mat-icon>
                        <div class="notify-bubble"
                          [style.top]="subscription?.baseSubscription.out_status_desc=='Pending Creation'?'60px':'50px'">
                          {{getPendingMessage(subscription?.baseSubscription)?.changeAmount}}
                        </div>
                      </ng-container>
                    </td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="align-center" style="width: 10%;">
                      ACTION
                    </th>
                    <td mat-cell *matCellDef="let subscription" class="align-center" style="width: 10%;">
                      <button
                        *ngIf="!subscription?.baseSubscription?.cancelingNceSub"
                        class="button button-red button-round"
                        style="margin: 5px 0px;"
                        (click)="manageSubscription(subscription?.baseSubscription)">Manage
                      </button>
                      <button
                        *ngIf="subscription?.baseSubscription?.out_addon_available == 'Y' && subscription?.baseSubscription?.out_status != 'XX' && !subscription?.baseSubscription?.cancelingNceSub && purchase == 'Y'"
                        [disabled]="!showSwitchButton(subscription?.baseSubscription?.out_subscription_id)"
                        class="button button-red button-round"
                        style="margin-bottom: 5px;"
                        (click)="getAddons(subscription?.baseSubscription)">
                        Add Add-on
                      </button>
                    </td>
                  </ng-container>

                  <!-- Add a new expandable column for pending add-ons -->
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let subscription" [attr.colspan]="NCESubTableDisplayedColumns.length">
                      <div class="pending-addons-container" 
                           *ngIf="subscription?.pendingAddOnSubscription?.length > 0"
                           [@detailExpand]="subscription === expandedElement ? 'expanded' : 'collapsed'">
                        <ng-container *ngFor="let addonItemPending of subscription.pendingAddOnSubscription; let i = index">
                          <div class="pending-addon-row">
                            <div class="description-col">
                              <i class="fas fa-caret-right"></i>
                              <span>{{addonItemPending?.description}}</span>
                            </div>
                            <div class="qty-col">{{addonItemPending?.quantity}}</div>
                            <div class="price-col">
                              {{addonItemPending?.itemPrice}}
                              <span *ngIf="addonItemPending?.billingFrequency == '1'">/mth</span>
                              <span *ngIf="addonItemPending?.billingFrequency == 'Y'">/yr</span>
                            </div>
                            <div class="total-col">
                              {{addonItemPending?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                            </div>
                            <div class="status-col">Pending Confirm</div>
                            <div class="action-col">
                              <span class="remove-icon" (click)="removeAddonPendingItem(subscription, i)" 
                                    ngbTooltip="Remove" placement="bottom">
                                <i class="fas fa-times"></i>
                              </span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="NCESubTableDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: NCESubTableDisplayedColumns;"
                      [class.expanded-row]="row?.pendingAddOnSubscription?.length > 0"
                      (click)="expandedElement = expandedElement === row ? null : row"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" 
                      class="expanded-detail"
                      [style.display]="row?.pendingAddOnSubscription?.length > 0 ? '' : 'none'"></tr>

                  <!-- Define the special column -->
                  <ng-container matColumnDef="specialColumn">
                    <td colspan="3" style="border-top: none;" class="text-right">
                    </td>
                  </ng-container>

                  <ng-container *ngFor="let annuityItemPending of annuityItemsPendingList; let i = index;">
                    <tr class="top-border-light-white">
                      <td class="align-center vertical-align-mid">
                        <button class="button button-red button-mid"
                          (click)="removeAnnuityPendingItem(annuityItemPending)">Remove</button>
                      </td>
                      <td class="pending-description-col position-relative">
                        <div class="arrowright"><i class="fas fa-caret-right fa-2x"></i></div>
                        <div class="description">{{annuityItemPending?.description}}</div>
                        <div class="result-info">
                          <div class="produc-secondary-title-wrapper">
                            <span>STOCK CODE:&nbsp;</span>
                            <span class="red-bold">{{annuityItemPending?.stockCode}}</span>
                          </div>
                        </div>
                      </td>
                      <td class="align-center">
                        <input class="align-center input-wrapper input-wrapper-small" disabled type="text"
                          [value]="annuityItemPending?.quantity">
                      </td>
                      <td class="align-center">{{annuityItemPending?.itemPrice}}
                        <span *ngIf="annuityItemPending?.billingFrequency == '1'">/mth</span>
                        <span *ngIf="annuityItemPending?.billingFrequency == 'Y'">/yr</span>
                      </td>
                      <td class="align-center">
                        {{annuityItemPending?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="align-center">&nbsp;</td>
                      <td class="align-center statustext">Pending Confirm</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr class="pending-grey-row info-row">
                      <td></td>
                      <td><b>SUBSCRIPTION DESCRIPTION&nbsp;&nbsp;&nbsp;&nbsp;
                          <input type="text" class="input" maxlength="30"
                            [(ngModel)]="annuityItemPending.subscriptionDescription"
                            (input)="cs.subscription_customer_ref_validation($event)"></b>
                      </td>
                      <td colspan="3" class="padding-r-x0">
                        <b>MPN ID</b>
                        <mat-form-field>
                          <input type="text" id="{{annuityItemPending.stockCode}}" class="subscriptionmpn"
                            integerOnly name="matmpnid" aria-label="Number" [(ngModel)]="annuityItemPending.mpn"
                            matInput #triggerSubMpn="matAutocompleteTrigger" [matAutocomplete]="autoSub">
                          <i class="material-icons align-arrow-right"
                            (click)="showAutoCompletePanel(triggerSubMpn);$event.stopPropagation()">arrow_drop_down</i>
                          <mat-autocomplete #autoSub="matAutocomplete">
                            <mat-option [value]="NoMPNText">
                              {{NoMPNText}}
                            </mat-option>
                            <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                              {{mpn}}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </td>
                      <td class="padding-x0">
                        <div id="{{annuityItemPending.mpn}}"> </div>
                      </td>
                      <td colspan="3" class="padding-x0">
                        <mat-spinner *ngIf="showMpnIdloading" mode="indeterminate" class="circle"
                          diameter="20"></mat-spinner>
                      </td>
                    </tr>

                    <tr colspan="1" class="pending-grey-row info-row"
                      *ngIf="annuityItemPending?.stockGroup == '85CU'">
                      <td></td>
                      <td colspan="1" class="padding-r-x0">
                        <b>OWNER EMAIL&nbsp;&nbsp;&nbsp;&nbsp;</b>
                        <input type="text" id="{{annuityItemPending.stockCode}}email" class="input ownerEmail"
                          [(ngModel)]="annuityItemPending.ownerEmail"
                          (blur)="checkSubscriptionOwnerEmailStatus(annuityItemPending)" required>
                      </td>
                      <td colspan="6" class="padding-x0">
                        <mat-spinner *ngIf="showEmailloading" mode="indeterminate" class="circle"
                          diameter="20"></mat-spinner>
                      </td>
                    </tr>

                  </ng-container>

                </table>

              </div>
              <div class="row">
                <div class="col button-center" *ngIf="purchase == 'Y'" style="margin-bottom: 20px;">
                  <button class="button button-red button-large button-center-left"
                    [disabled]="isSubscriptionResponseLoading || (subscriptionResponse?.status != 'Success'  && subscriptionResponse?.status != 'MCA')"
                    (click)="getProductList('OnlineService');">Add new product</button>
                  <button class="button button-red button-large button-center-right"
                    [disabled]="!hasSubPending||hasZeroQtySub || !checkMpnId || (isToCheckOwnerEmail && !checkEmail) || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
                    [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                    matTooltip="Requires Purchasing Permissions" (click)="confirmSubscription()">Confirm All</button>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- License Subscription -->
        <mat-expansion-panel *ngIf="annuity?.containsLegacy == 'Y'" [expanded]="panelLicenseSubscriptionOpen">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">
              LICENSE SUBSCRIPTION
            </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text"> {{ licenseSubs?.length ? licenseSubs.length : "0" }} Subscription(s) </span>
              <mat-spinner *ngIf="isCSPItemLoading" mode="indeterminate" class="circle cSPCustomerEntitlements-loading"
                diameter="20">
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <!-- <dd-csp-license-subscription></dd-csp-license-subscription> -->
          <div style="font-size: 12px;">
            <div class="panel-body">
              <div *ngIf="(licenseSubs?.length || annuityItemsPendingList?.length) && !isCSPItemLoading">
                <div class="mTable-header">
                  <div class="row filter-wrapper">
                    <div class="col-md-3">
                      <div class="searchInputGroup">
                        <div class="searchIcon">
                          <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="searchSubscription">
                      </div>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-3 listpart select-out-wrapper">
                      <ng-select class="customDropdwon" [multiple]="true" [items]="statusList" bindValue="value"
                        bindLabel="name" placeholder="Status" [(ngModel)]="selectedStatus" (change)="FilterStatus()">
                        <ng-template ng-header-tmp>
                          <div>
                            <button class="btn btn-link" (click)="onSelectAll()">Select All</button>
                            <button class="btn btn-link" (click)="onClearAll()">Clear All</button>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div *ngIf="!hasPendingAzureProduct" class="col-md-1 margin-right-x45"></div>

                    <div class="migrate-all-button">
                      <div>
                        <button *ngIf="showAzurePlan && isMCASigned"
                          class="button button-red button-large auzre-plan-width"
                          (click)="checkAzureUpgradeEligibility(upgradeAzureContainer, $event)"
                          [disabled]="!subscriptionResponse || subscriptionResponse?.status == 'Fail'">
                          Upgrade to Azure Plan
                        </button>
                        <mat-spinner *ngIf="showAzureButtonUpgradeloading" mode="indeterminate"
                          class="circle upgrade-azure-plan-loading" diameter="20">
                        </mat-spinner>
                      </div>
                      <!-- <div colspan="4" *ngIf="showAzureButtonUpgradeloading" class="azure-loading">
                        <mat-spinner mode="indeterminate" class="circle" diameter="20"></mat-spinner>
                      </div> -->
                      <div *ngIf="isAzureUpgradeInProgress"
                        class="basic-icon information-icon azureplan-information-icon"></div>
                      <label *ngIf="isAzureUpgradeInProgress">Azure Plan Upgrade In Progress</label>
                      <div *ngIf="hasPendingAzureProduct"
                        class="basic-icon information-icon azureplan-information-icon"></div>
                      <label *ngIf="hasPendingAzureProduct">All Azure subscriptions must be active for azure plan
                        migration</label>
                    </div>

                  </div>
                </div>
                <div class="mTable">
                  <table class="table display-block">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 5%"></th>
                        <th scope="col" style="width: 40%">DESCRIPTION</th>
                        <th scope="col" class="align-center" style="width: 9%">CONFIRMED QTY</th>
                        <th scope="col" class="align-center" style="width: 9%">QTY</th>
                        <th scope="col" class="align-right" style="width: 9%">PRICE</th>
                        <th scope="col" class="align-right" style="width: 9%">TOTAL</th>
                        <th scope="col" class="align-center" style="width: 9%">STATUS</th>
                        <th scope="col" class="align-center" style="width: 5%">ADD-ON</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container
                        *ngFor="let subscription of licenseSubs | cspFilter: searchSubscription:searchStatusList:subscriptionActions; let idx = index; trackBy: trackByFn">
                        <tr style="border-bottom: none;" [id]="subscription?.baseSubscription?.out_subscription_id">
                          <td [attr.rowspan]="pendingRenewalCheck(subscription?.baseSubscription?.out_status_desc)">
                            <div class="checkbox-center" *ngIf="
                                subscription?.baseSubscription?.out_charge_type !=='NCE' &&
                                showSwitchButton(subscription?.baseSubscription?.out_subscription_id) &&
                                !getPendingMessage(subscription?.baseSubscription).out_message.includes('Pending') &&
                                !checkSubInProgress(subscription?.baseSubscription)
                              ">
                              <mat-slide-toggle [disabled]="
                                  !showSwitchButton(subscription?.baseSubscription?.out_subscription_id) ||
                                  (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)
                                "
                                [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                                matTooltip="Requires Purchasing Permissions"
                                [checked]="subscription?.baseSubscription?.out_status != 'XX'"
                                (change)="toggleBaseActive($event, subscription, idx)" class="activesuspend">
                              </mat-slide-toggle>
                            </div>
                          </td>

                          <td class="push-left-75"
                            [attr.rowspan]="pendingRenewalCheck(subscription?.baseSubscription?.out_status_desc)">
                            <span class="description">{{subscription?.baseSubscription?.out_stk_description}}</span>

                            <div class="result-info">
                              <div *ngIf="subscription?.baseSubscription?.out_charge_type !=='NCE'"
                                class="produc-secondary-title-wrapper">
                                <span
                                  (click)="subscription?.baseSubscription?.out_status != 'XX' && showSwitchButton(subscription?.baseSubscription?.out_subscription_id) && enableEditMpn(subscription)"
                                  *ngIf="!subscription?.baseSubscription?.editMpnBool">MPN:&nbsp;</span>
                                <span *ngIf="!subscription?.baseSubscription?.editMpnBool"
                                  (click)="subscription?.baseSubscription?.out_status != 'XX' && showSwitchButton(subscription?.baseSubscription?.out_subscription_id) && !checkSubInProgress(subscription?.baseSubscription) && enableEditMpn(subscription) "
                                  class="cursor-pointer red-bold">{{subscription?.baseSubscription?.out_mpnid}}&nbsp;</span>
                                <span class="divider-wrapper"
                                  *ngIf="!subscription?.baseSubscription?.editMpnBool">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                <span
                                  (click)="subscription?.baseSubscription?.out_status != 'XX' && showSwitchButton(subscription?.baseSubscription?.out_subscription_id)  && enableEditDesc(subscription)"
                                  *ngIf="!subscription?.baseSubscription?.editDescBool && subscription?.baseSubscription?.out_sub_description">DESC:&nbsp;</span>
                                <span
                                  *ngIf="!subscription?.baseSubscription?.editDescBool && subscription?.baseSubscription?.out_sub_description"
                                  class="cursor-pointer red-bold"
                                  (click)="subscription?.baseSubscription?.out_status != 'XX' && showSwitchButton(subscription?.baseSubscription?.out_subscription_id) && !checkSubInProgress(subscription?.baseSubscription) && enableEditDesc(subscription)">{{subscription?.baseSubscription?.out_sub_description}}</span>
                                <mat-form-field *ngIf="subscription?.baseSubscription?.editMpnBool">
                                  <input type="text" placeholder="Select / Enter New MPN ID" aria-label="Number"
                                    id="{{subscription.baseSubscription.editMpnIdValue}}" integerOnly
                                    [(ngModel)]="subscription.baseSubscription.editMpnIdValue" matInput
                                    (blur)="onMPNIdChange('base', subscription.baseSubscription, idx, 0);"
                                    #trigger="matAutocompleteTrigger" [matAutocomplete]="auto">
                                  <i class="material-icons align-arrow-right"
                                    (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                                  <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option [value]="NoMPNText">
                                      {{NoMPNText}}
                                    </mat-option>
                                    <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                                      {{mpn}}
                                    </mat-option>
                                  </mat-autocomplete>
                                  <mat-icon matSuffix *ngIf="currentUserModel.isAU" class="editmpnidicon"
                                    placement="bottom"
                                    ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-AU/ or call the Microsoft Partner Hotline on 13 20 58 (Options 2,5,1)">
                                    info</mat-icon>

                                  <mat-icon matSuffix *ngIf="!currentUserModel.isAU" class="editmpnidicon"
                                    placement="bottom"
                                    ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-NZ/ or call the Microsoft New Zealand Service Centre 0800 800 004 (Options 2, 2, 1)">
                                    info</mat-icon>
                                </mat-form-field>
                                <mat-form-field *ngIf="subscription?.baseSubscription?.editDescBool">
                                  <input matInput [(ngModel)]="subscription.baseSubscription.editDescValue"
                                    (blur)="editDesc(subscription,idx, 0)"
                                    (keyup.enter)="editDesc(subscription,idx, 0)">
                                </mat-form-field>
                              </div>
                              <mat-spinner *ngIf="showMpnIdloading" style="float: right;" mode="indeterminate"
                                class="circle" diameter="20">
                              </mat-spinner>
                              <div class="produc-secondary-title-wrapper">
                                <span class="divider-wrapper" *ngIf="">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                <span>STOCK CODE:&nbsp;</span>
                                <span class="red-bold">{{subscription?.baseSubscription?.out_stock_code}}</span>

                                <div class="result-info">
                                  <span>BILLING:&nbsp;</span>
                                  <span
                                    class="red-bold">{{subscription?.baseSubscription?.out_billing_freq_desc}}</span>

                                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                  <span>BILLED UNTIL:&nbsp;</span>
                                  <span class="red-bold">{{subscription?.baseSubscription?.out_end_usage}}</span>
                                </div>

                                <!-- Scheduled changes hover -->
                                <span class="produc-secondary-title-wrapper"
                                  *ngIf="getScheduledChange(subscription.baseSubscription.out_subscription_id)">
                                  <a style="cursor: pointer;" placement="bottom" [ngbTooltip]="ScheduleChangesUpdate"
                                    #t2="ngbTooltip">
                                    <span class="small-logo-wrapper">
                                      <img style="width: 16px; height: 16px;" src="../images/new_ui/clock-red.svg">
                                    </span>
                                    SCHEDULED CHANGES
                                  </a>
                                </span>
                                <ng-template #ScheduleChangesUpdate>
                                  <div class="d-flex flex-column" style="text-align: left;">
                                    <span>Scheduled Changes for next renewal</span>
                                    <br />
                                    <span>Quantity: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.quantity }}</span>
                                    <span>SKU: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.stockCode.toUpperCase() }}</span>
                                    <span *ngIf="getScheduledChange(subscription.baseSubscription.out_subscription_id)?.billingCycle">Billing cycle: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.billingCycle }}</span>
                                    <span>Term: {{ cs.getTermDisplay(getScheduledChange(subscription.baseSubscription.out_subscription_id)?.term) }}</span>
                                    <span *ngIf="getScheduledChange(subscription.baseSubscription.out_subscription_id)?.customTermEndDate">End Date Alignment: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.customTermEndDate |  date: 'dd/MM/yyyy' }}</span>
                                  </div>
                                </ng-template>
                              </div>
                            </div>
                          </td>

                          <td class="align-center"
                            [attr.rowspan]="pendingRenewalCheck(subscription?.baseSubscription?.out_status_desc)">
                            {{subscription?.baseSubscription?.out_confirmed_qty}}</td>

                          <!-- qty  -->
                          <td class="align-center align-top"
                            [attr.rowspan]="pendingRenewalCheck(subscription?.baseSubscription?.out_status_desc)">
                            <input class="align-center input-wrapper input-wrapper-small" type="text" [disabled]="
                                !showSwitchButton(subscription?.baseSubscription?.out_subscription_id)
                                || subscription?.baseSubscription?.out_stock_group == '85CU'
                                || subscription?.baseSubscription?.out_status == 'XX'
                                || !subscription?.baseSubscription?.out_activeSuspend
                                || getPendingMessage(subscription?.baseSubscription).out_message.includes('Pending')
                                || purchase != 'Y'
                              " (keypress)="isNumberKey($event)" [(ngModel)]="subscription.baseSubscription.out_qty"
                              integerOnly (ngModelChange)="updateQty('base', subscription?.baseSubscription, idx, 0)">
                          </td>

                          <td class="align-right push-left-75">
                            {{subscription?.baseSubscription?.out_price | currency:'AUD':'symbol-narrow':'.2-2'}}
                            <span *ngIf="subscription?.baseSubscription?.out_billing_freq == '1'">/mth</span>
                            <span *ngIf="subscription?.baseSubscription?.out_billing_freq == 'Y'">/yr</span>
                          </td>

                          <td class="align-right push-left-75">
                            {{subscription?.baseSubscription?.out_amount | currency:'AUD':'symbol-narrow':'.2-2'}}
                            <span *ngIf="subscription?.baseSubscription?.out_billing_freq == '1'">/mth</span>
                            <span *ngIf="subscription?.baseSubscription?.out_billing_freq == 'Y'">/yr</span>
                          </td>

                          <td class="align-center statustext"
                            *ngIf="!getPendingMessage(subscription?.baseSubscription).changeAmount">
                            {{subscription?.baseSubscription?.out_status_desc}}
                            <mat-spinner
                              *ngIf="subscription?.baseSubscription?.cancelingLoading && !subscription?.baseSubscription?.cancelingNceSub"
                              style="margin: auto;" mode="indeterminate" class="circle" diameter="20">
                            </mat-spinner>
                          </td>
                          <td class="align-center statustext position-relative"
                            *ngIf="getPendingMessage(subscription?.baseSubscription).changeAmount">
                            <span
                              class="pending-vendor-confirmation display-inline-block">{{getPendingMessage(subscription?.baseSubscription)?.out_status_desc}}</span><br />
                            <mat-icon class="usernameicon" placement="bottom"
                              matTooltip="{{getPendingMessage(subscription?.baseSubscription)?.out_message}}">
                              info
                            </mat-icon>
                            <div class="notify-bubble"
                              [style.top]="subscription?.baseSubscription.out_status_desc=='Pending Creation'?'60px':'50px'">
                              {{getPendingMessage(subscription?.baseSubscription)?.changeAmount}}
                            </div>
                          </td>
                          <td class="align-center">
                            <button
                              *ngIf="subscription?.baseSubscription?.out_addon_available == 'Y' && subscription?.baseSubscription?.out_status != 'XX' && !subscription?.baseSubscription?.cancelingNceSub"
                              [disabled]="!showSwitchButton(subscription?.baseSubscription?.out_subscription_id)"
                              class="button button-red button-round"
                              (click)="getAddons(subscription?.baseSubscription)">
                              Add Add-on
                            </button>
                          </td>
                        </tr>

                        <tr *ngIf="subscription.pendingAddOnSubscription?.length > 0" class="pending-addon-row">
                          <td colspan="7" class="pending-addon-notice">
                            <div class="alert alert-info">
                              {{ subscription.pendingAddOnSubscription?.length }} pending add-on(s) to be confirmed
                            </div>
                          </td>
                        </tr>

                        <ng-container *ngFor="let addOnSubscription of subscription?.addOnSubscription; let addonIdx = index">
                          <tr [id]="addOnSubscription?.out_subscription_id">
                            <td>
                              <div class="checkbox-center"
                                *ngIf="addOnSubscription.out_charge_type !=='NCE' && showSwitchButton(addOnSubscription?.out_subscription_id)">
                                <mat-slide-toggle
                                  [disabled]="!showSwitchButton(addOnSubscription?.out_subscription_id) || addOnSubscription.out_status_desc == 'Pending Base Suspended' || addOnSubscription.out_status_desc == 'Base Suspended' || getPendingMessage(addOnSubscription).out_message.includes('Pending') || !subscription?.baseSubscription?.out_activeSuspend"
                                  [checked]="addOnSubscription?.out_activeSuspend"
                                  (change)="toggleAddonActive($event, addOnSubscription, idx, addonIdx)"
                                  class="activesuspend">
                                </mat-slide-toggle>
                              </div>
                            </td>

                            <td class="pending-description-col position-relative">
                              <div class="arrowright"><i class="fas fa-caret-right fa-2x"></i></div>
                              <div class="description">
                                {{addOnSubscription?.out_stk_description}}
                              </div>

                              <div class="result-info">
                                  <span *ngIf="!addOnSubscription?.editMpnBool && addOnSubscription?.out_mpnid"
                                    (click)="addOnSubscription?.out_status != 'XX' && showSwitchButton(addOnSubscription?.out_subscription_id) && enableAddonEditMpn(addOnSubscription)">MPN:&nbsp;</span>
                                  <span *ngIf="!addOnSubscription?.editMpnBool && addOnSubscription?.out_mpnid"
                                    (click)="addOnSubscription?.out_status != 'XX' && showSwitchButton(addOnSubscription?.out_subscription_id) && enableAddonEditMpn(addOnSubscription)"
                                    class="cursor-pointer red-bold">{{addOnSubscription?.out_mpnid}}&nbsp;</span>
                                  <span class="divider-wrapper"
                                    *ngIf="!addOnSubscription?.editMpnBool && addOnSubscription?.out_mpnid">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                  <span
                                    *ngIf="!addOnSubscription?.editDescBool && addOnSubscription?.out_sub_description"
                                    (click)="addOnSubscription?.out_status != 'XX' && showSwitchButton(addOnSubscription?.out_subscription_id) && enableAddonEditDesc(addOnSubscription)">DESC:&nbsp;</span>
                                  <span
                                    *ngIf="!addOnSubscription?.editDescBool && addOnSubscription?.out_sub_description"
                                    class="cursor-pointer red-bold"
                                    (click)="addOnSubscription?.out_status != 'XX' && showSwitchButton(addOnSubscription?.out_subscription_id) && enableAddonEditDesc(addOnSubscription)">{{addOnSubscription?.out_sub_description}}</span>
                                  <mat-form-field *ngIf="addOnSubscription?.editMpnBool">
                                    <input type="text" name="matmpnid" placeholder="Select / Enter New MPN ID"
                                      aria-label="Number" [(ngModel)]="addOnSubscription.editMpnIdValue"
                                      id="{{addOnSubscription.editMpnIdValue}}" integerOnly
                                      (keyup.enter)="editAddonMpnId(addOnSubscription, idx, addonIdx)" matInput
                                      #triggerAddon="matAutocompleteTrigger" [matAutocomplete]="auto">
                                    <i class="material-icons align-arrow-right"
                                      (click)="showAutoCompletePanel(triggerAddon);$event.stopPropagation()">arrow_drop_down</i>
                                    <mat-autocomplete #auto="matAutocomplete"
                                      (optionSelected)="editAddonMpnId(addOnSubscription, idx, addonIdx)">
                                      <mat-option [value]="NoMPNText">
                                        {{NoMPNText}}
                                      </mat-option>
                                      <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                                        {{mpn}}
                                      </mat-option>
                                    </mat-autocomplete>
                                    <!--   <mat-icon matSuffix class="editmpnidicon" placement="bottom"
                                      ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-AU/ or call the Microsoft Partner Hotline on 13 20 58 (Options 2,5,1)">
                                      info</mat-icon> -->
                                    <mat-icon matSuffix *ngIf="currentUserModel.isAU" class="editmpnidicon"
                                      placement="bottom"
                                      ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-AU/ or call the Microsoft Partner Hotline on 13 20 58 (Options 2,5,1)">
                                      info</mat-icon>

                                    <mat-icon matSuffix *ngIf="!currentUserModel.isAU" class="editmpnidicon"
                                      placement="bottom"
                                      ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-NZ/ or call the Microsoft New Zealand Service Centre 0800 800 004 (Options 2, 2, 1)">
                                      info</mat-icon>
                                  </mat-form-field>
                                  <mat-form-field *ngIf="addOnSubscription?.editDescBool">
                                    <input matInput [(ngModel)]="addOnSubscription.editDescValue"
                                      (blur)="editAddonDesc(addOnSubscription, idx, addonIdx)"
                                      (keyup.enter)="editAddonDesc(addOnSubscription, idx, addonIdx)">
                                  </mat-form-field>
                                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>

                                <mat-spinner *ngIf="showMpnIdloading" style="float: right;" mode="indeterminate"
                                  class="circle" diameter="20">
                                </mat-spinner>

                                <div class="produc-secondary-title-wrapper">
                                  <span>STOCK CODE:&nbsp;</span>
                                  <span class="red-bold">{{addOnSubscription?.out_stock_code}}</span>
                                  <div class="result-info">
                                    <span>BILLING:&nbsp;</span>
                                    <span class="red-bold">{{addOnSubscription.out_billing_freq_desc}}</span>

                                    <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                    <span>BILLED UNTIL:&nbsp;</span>
                                    <span class="red-bold">{{addOnSubscription.out_end_usage}}</span>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td class="align-center">{{addOnSubscription?.out_confirmed_qty}}</td>
                            <td class="align-center align-top">
                              <input class="align-center input-wrapper input-wrapper-small" type="text"
                                [disabled]="!showSwitchButton(addOnSubscription?.out_subscription_id) || addOnSubscription?.out_stock_group == '85CU' || addOnSubscription?.out_status == 'XX' || !addOnSubscription?.out_activeSuspend || subscription?.baseSubscription?.out_status == 'XX' || !subscription?.baseSubscription?.out_activeSuspend || getPendingMessage(addOnSubscription).out_message.includes('Pending') || purchase != 'Y'"
                                (keypress)="isNumberKey($event)" [(ngModel)]="addOnSubscription.out_qty"
                                (ngModelChange)="updateQty('addon', addOnSubscription, idx, addonIdx)">
                            </td>
                            <td class="align-right push-left-75">
                              {{addOnSubscription?.out_price | currency:'AUD':'symbol-narrow':'.2-2'}}
                              <span *ngIf="addOnSubscription?.out_billing_freq == '1'">/mth</span>
                              <span *ngIf="addOnSubscription?.out_billing_freq == 'Y'">/yr</span>
                            </td>
                            <td class="align-right push-left-75">
                              {{addOnSubscription?.out_amount | currency:'AUD':'symbol-narrow':'.2-2'}}
                            </td>
                            <td class="align-center statustext"
                              *ngIf="!addOnSubscription?.out_action_status && !addOnSubscription?.out_error_message">
                              {{addOnSubscription?.out_status_desc}}
                              <mat-spinner
                                *ngIf="addOnSubscription?.cancelingLoading && !addOnSubscription?.cancelingNceSub"
                                style="margin: auto;" mode="indeterminate" class="circle" diameter="20">
                              </mat-spinner>
                            </td>
                            <td class="align-center statustext position-relative"
                              *ngIf="getPendingMessage(addOnSubscription)?.changeAmount">
                              <span
                                class="pending-vendor-confirmation display-inline-block">{{getPendingMessage(addOnSubscription)?.out_status_desc}}</span><br />
                              <mat-icon class="usernameicon" placement="bottom"
                                ngbTooltip="{{getPendingMessage(addOnSubscription)?.out_message}}">
                                info
                              </mat-icon>
                              <div class="notify-bubble"
                                [style.top]="addOnSubscription?.out_status_desc=='Pending Creation'?'60px':'40px'">
                                {{getPendingMessage(addOnSubscription)?.changeAmount}}</div>
                            </td>
                            <td> <button class="button button-red button-mid addonbtn mt-3"
                                style="margin-top: -2px !important;"
                                *ngIf="!addOnSubscription?.cancelingNceSub"
                                (click)="manageSubscription(addOnSubscription)">Manage</button>

                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </tbody>
                    <tfoot>
                      <div class="row totalPrice-wrapper">
                        <div class="col align-right" *ngIf="pendingTotal != 0">
                          <span><b>Pending Total (Ex GST) </b>
                            <span class="pendingTotal">{{ pendingTotal |
                              currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                        </div>
                        <div class="col align-right" *ngIf="pendingTotal == 0">
                          <span><b>Pending Total (Ex GST) </b>
                            <span class="pendingTotal">{{ 0 |
                              currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                        </div>
                        <div class="col align-left">
                          <span><b>Active Total (Ex GST) </b>
                            <span class="activeTotal">{{activeTotal |
                              currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                        </div>
                      </div>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col button-center" *ngIf="purchase == 'Y'" style="margin-bottom: 20px;">
                  <button class="button button-red button-large button-center-left"
                    [disabled]="isSubscriptionResponseLoading || (subscriptionResponse?.status != 'Success'  && subscriptionResponse?.status != 'MCA')"
                    (click)="getProductList('OnlineService');">Add new product</button>
                  <button class="button button-red button-large button-center-right"
                    [disabled]="!hasSubPending||hasZeroQtySub || !checkMpnId || (isToCheckOwnerEmail && !checkEmail) || invalidQtyInput || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
                    [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                    matTooltip="Requires Purchasing Permissions" (click)="confirmSubscription()">Confirm All</button>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Azure Usage Subscription-->
        <mat-expansion-panel [expanded]="panelAzureUsageSubscriptionOpen">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">
              AZURE USAGE SUBSCRIPTION
            </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text"> {{ azureUsageSubs?.length ? azureUsageSubs.length : "0" }} Subscription(s)
              </span>
              <mat-spinner *ngIf="isCSPItemLoading" mode="indeterminate" class="circle cSPCustomerEntitlements-loading"
                diameter="20">
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div role="tabpanel" aria-labelledby="headingSubscription">
            <div class="panel-body">
              <div *ngIf="(azureUsageSubs?.length || annuityItemsPendingList?.length) && !isCSPItemLoading">
                <div class="mTable-header">
                  <div class="row filter-wrapper">
                    <div class="col-md-3">
                      <div class="searchInputGroup">
                        <div class="searchIcon">
                          <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" placeholder="Filter"
                          [(ngModel)]="searchAzureUsageSubscription">
                      </div>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-3 listpart select-out-wrapper">
                      <ng-select class="customDropdwon" [multiple]="true" [items]="statusList" bindValue="value"
                        bindLabel="name" placeholder="Status" [(ngModel)]="azureUsageSubsSelectedStatus"
                        (change)="FilterStatus(true)">
                        <ng-template ng-header-tmp>
                          <div>
                            <button class="btn btn-link" (click)="onSelectAll(true)">Select All</button>
                            <button class="btn btn-link" (click)="onClearAll(true)">Clear All</button>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div *ngIf="!hasPendingAzureProduct" class="col-md-1 margin-right-x45"></div>

                    <div class="migrate-all-button">
                      <div>
                        <button *ngIf="showAzurePlan && isMCASigned"
                          class="button button-red button-large auzre-plan-width"
                          (click)="checkAzureUpgradeEligibility(upgradeAzureContainer, $event)"
                          [disabled]="!subscriptionResponse || subscriptionResponse?.status == 'Fail'">
                          Upgrade to Azure Plan
                        </button>
                        <!-- <mat-spinner *ngIf="showAzureButtonUpgradeloading" mode="indeterminate"
                        class="circle azure-loading" diameter="20">
                        </mat-spinner> -->
                      </div>
                      <div colspan="4" *ngIf="showAzureButtonUpgradeloading" class="azure-loading">
                        <mat-spinner mode="indeterminate" class="circle" diameter="20"></mat-spinner>
                      </div>
                      <div *ngIf="isAzureUpgradeInProgress"
                        class="basic-icon information-icon azureplan-information-icon"></div>
                      <label *ngIf="isAzureUpgradeInProgress">Azure Plan Upgrade In Progress</label>
                      <div *ngIf="hasPendingAzureProduct"
                        class="basic-icon information-icon azureplan-information-icon"></div>
                      <label *ngIf="hasPendingAzureProduct">All Azure subscriptions must be active for azure plan
                        migration</label>
                    </div>

                  </div>
                </div>
                <div class="mTable">
                  <table class="table display-block">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 40%">DESCRIPTION</th>
                        <th scope="col" class="align-center" style="width: 10%">CONFIRMED QTY</th>
                        <th scope="col" class="align-center" style="width: 10%">QTY</th>
                        <th scope="col" class="align-right" style="width: 10%">PRICE</th>
                        <th scope="col" class="align-right" style="width: 10%">TOTAL</th>
                        <th scope="col" class="align-center" style="width: 10%">STATUS</th>
                        <th scope="col" style="width: 10%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container
                        *ngFor="let subscription of azureUsageSubs | cspFilter: searchAzureUsageSubscription:azureUsageSearchStatusList:subscriptionActions; let idx = index; trackBy: trackByFn">
                        <tr style="border-bottom: none;" [id]="subscription?.baseSubscription?.out_subscription_id">
                          <td [attr.rowspan]="pendingRenewalCheck(subscription?.baseSubscription?.out_status_desc)">
                            <span class="description">
                              {{subscription?.baseSubscription?.out_stk_description}}
                            </span>
                            <div class="result-info">
                              <div class="produc-secondary-title-wrapper">
                                <span
                                  (click)="subscription?.baseSubscription?.out_status != 'XX' && showSwitchButton(subscription?.baseSubscription?.out_subscription_id) && enableEditMpn(subscription)"
                                  *ngIf="!subscription?.baseSubscription?.editMpnBool">
                                  MPN:&nbsp;
                                </span>
                                <span *ngIf="!subscription?.baseSubscription?.editMpnBool"
                                  (click)="subscription?.baseSubscription?.out_status != 'XX' && showSwitchButton(subscription?.baseSubscription?.out_subscription_id) && !checkSubInProgress(subscription?.baseSubscription) && enableEditMpn(subscription) "
                                  class="cursor-pointer red-bold">{{subscription?.baseSubscription?.out_mpnid}}&nbsp;</span>
                                <span class="divider-wrapper"
                                  *ngIf="!subscription?.baseSubscription?.editMpnBool">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                <span
                                  (click)="subscription?.baseSubscription?.out_status != 'XX' && showSwitchButton(subscription?.baseSubscription?.out_subscription_id)  && enableEditDesc(subscription)"
                                  *ngIf="!subscription?.baseSubscription?.editDescBool && subscription?.baseSubscription?.out_sub_description">DESC:&nbsp;</span>
                                <span
                                  *ngIf="!subscription?.baseSubscription?.editDescBool && subscription?.baseSubscription?.out_sub_description"
                                  class="cursor-pointer red-bold"
                                  (click)="subscription?.baseSubscription?.out_status != 'XX' && showSwitchButton(subscription?.baseSubscription?.out_subscription_id) && !checkSubInProgress(subscription?.baseSubscription) && enableEditDesc(subscription)">{{subscription?.baseSubscription?.out_sub_description}}</span>
                                <mat-form-field *ngIf="subscription?.baseSubscription?.editMpnBool">
                                  <input type="text" placeholder="Select / Enter New MPN ID" aria-label="Number"
                                    id="{{subscription.baseSubscription.editMpnIdValue}}" integerOnly
                                    [(ngModel)]="subscription.baseSubscription.editMpnIdValue" matInput
                                    (blur)="onMPNIdChange('base', subscription.baseSubscription, idx, 0);"
                                    #trigger="matAutocompleteTrigger" [matAutocomplete]="auto">
                                  <i class="material-icons align-arrow-right"
                                    (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                                  <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option [value]="NoMPNText">
                                      {{NoMPNText}}
                                    </mat-option>
                                    <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                                      {{mpn}}
                                    </mat-option>
                                  </mat-autocomplete>
                                  <!--  <mat-icon matSuffix class="editmpnidicon" placement="bottom"
                                    ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-AU/ or call the Microsoft Partner Hotline on 13 20 58 (Options 2,5,1)">
                                    info</mat-icon> -->
                                  <mat-icon matSuffix *ngIf="currentUserModel.isAU" class="editmpnidicon"
                                    placement="bottom"
                                    ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-AU/ or call the Microsoft Partner Hotline on 13 20 58 (Options 2,5,1)">
                                    info</mat-icon>

                                  <mat-icon matSuffix *ngIf="!currentUserModel.isAU" class="editmpnidicon"
                                    placement="bottom"
                                    ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-NZ/ or call the Microsoft New Zealand Service Centre 0800 800 004 (Options 2, 2, 1)">
                                    info</mat-icon>
                                </mat-form-field>
                                <mat-form-field *ngIf="subscription?.baseSubscription?.editDescBool">
                                  <input matInput [(ngModel)]="subscription.baseSubscription.editDescValue"
                                    (blur)="editDesc(subscription,idx, 0)"
                                    (keyup.enter)="editDesc(subscription,idx, 0)">
                                </mat-form-field>

                              </div>
                              <mat-spinner *ngIf="showMpnIdloading" style="float: right;" mode="indeterminate"
                                class="circle" diameter="20">
                              </mat-spinner>
                              <div class="produc-secondary-title-wrapper">
                                <span class="divider-wrapper" *ngIf="">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                <span>STOCK CODE:&nbsp;</span>
                                <span class="red-bold">{{subscription?.baseSubscription?.out_stock_code}}</span>

                                <div class="result-info">
                                  <span>BILLING:&nbsp;</span>
                                  <span class="red-bold">
                                    {{subscription?.baseSubscription?.out_billing_freq_desc}}
                                  </span>
                                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                  <span>BILLED UNTIL:&nbsp;</span>
                                  <span class="red-bold">
                                    {{subscription?.baseSubscription?.out_end_usage}}
                                  </span>
                                </div>

                                <!-- Scheduled changes hover -->
                                <span class="produc-secondary-title-wrapper"
                                  *ngIf="getScheduledChange(subscription.baseSubscription.out_subscription_id)">
                                  <a style="cursor: pointer;" placement="bottom" [ngbTooltip]="ScheduleChangesUpdate"
                                    #t2="ngbTooltip">
                                    <span class="small-logo-wrapper">
                                      <img style="width: 16px; height: 16px;" src="../images/new_ui/clock-red.svg">
                                    </span>
                                    SCHEDULED CHANGES
                                  </a>
                                </span>
                                <ng-template #ScheduleChangesUpdate>
                                  <div class="d-flex flex-column" style="text-align: left;">
                                    <span>Scheduled Changes for next renewal</span>
                                    <br />
                                    <span>Quantity: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.quantity }}</span>
                                    <span>SKU: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.stockCode.toUpperCase() }}</span>
                                    <span *ngIf="getScheduledChange(subscription.baseSubscription.out_subscription_id)?.billingCycle">Billing cycle: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.billingCycle }}</span>
                                    <span>Term: {{ cs.getTermDisplay(getScheduledChange(subscription.baseSubscription.out_subscription_id)?.term) }}</span>
                                    <span *ngIf="getScheduledChange(subscription.baseSubscription.out_subscription_id)?.customTermEndDate">End Date Alignment: {{ getScheduledChange(subscription.baseSubscription.out_subscription_id)?.customTermEndDate |  date: 'dd/MM/yyyy' }}</span>
                                  </div>
                                </ng-template>
                              </div>
                            </div>
                          </td>
                          <td class="align-center"
                            [attr.rowspan]="pendingRenewalCheck(subscription?.baseSubscription?.out_status_desc)">
                            {{subscription?.baseSubscription?.out_confirmed_qty}}</td>

                          <td class="align-center align-top"
                            [attr.rowspan]="pendingRenewalCheck(subscription?.baseSubscription?.out_status_desc)">
                            <input class="align-center input-wrapper input-wrapper-small" type="text"
                              [disabled]="!showSwitchButton(subscription?.baseSubscription?.out_subscription_id) || subscription?.baseSubscription?.out_stock_group == '85CU' || subscription?.baseSubscription?.out_status == 'XX' || subscription?.baseSubscription?.out_status_desc !== 'Active' || getPendingMessage(subscription?.baseSubscription).out_message.includes('Pending') || purchase != 'Y'"
                              (keypress)="isNumberKey($event)" [(ngModel)]="subscription.baseSubscription.out_qty"
                              integerOnly (ngModelChange)="updateQty('base', subscription?.baseSubscription, idx, 0)">
                          </td>

                          <td class="align-right push-left-75">
                            {{subscription?.baseSubscription?.out_price | currency:'AUD':'symbol-narrow':'.2-2'}}
                            <span *ngIf="subscription?.baseSubscription?.out_billing_freq == '1'">/mth</span>
                            <span *ngIf="subscription?.baseSubscription?.out_billing_freq == 'Y'">/yr</span>

                          </td>
                          <td class="align-right push-left-75"
                            *ngIf="subscription?.baseSubscription?.out_stock_group == '85CU'">
                            <button class="button button-red button-mid addonbtn"
                              (click)="estimateCost(subscription?.baseSubscription)"
                              *ngIf="!subscription.baseSubscription.loadingStatus && !subscription?.baseSubscription?.priceLoadingStatus">Estimate
                              Cost</button>
                            <mat-progress-bar [color]="'accent'" [mode]="'indeterminate'"
                              *ngIf="!subscription?.baseSubscription?.priceLoadingStatus && subscription.baseSubscription.loadingStatus">
                            </mat-progress-bar>
                            <span
                              *ngIf="subscription?.baseSubscription?.priceLoadingStatus">{{subscription?.baseSubscription?.out_amount
                              | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                          </td>
                          <td class="align-right push-left-75"
                            *ngIf="subscription?.baseSubscription?.out_stock_group != '85CU'">
                            {{subscription?.baseSubscription?.out_amount | currency:'AUD':'symbol-narrow':'.2-2'}}
                          </td>
                          <td class="align-center statustext"
                            *ngIf="!getPendingMessage(subscription?.baseSubscription).changeAmount">
                            {{subscription?.baseSubscription?.out_status_desc}}
                            <mat-spinner
                              *ngIf="subscription?.baseSubscription?.cancelingLoading && !subscription?.baseSubscription?.cancelingNceSub"
                              style="margin: auto;" mode="indeterminate" class="circle" diameter="20">
                            </mat-spinner>
                          </td>
                          <td class="align-center statustext position-relative"
                            *ngIf="getPendingMessage(subscription?.baseSubscription).changeAmount">
                            <span
                              class="pending-vendor-confirmation display-inline-block">{{getPendingMessage(subscription?.baseSubscription)?.out_status_desc}}</span><br />
                            <mat-icon class="usernameicon" placement="bottom"
                              ngbTooltip="{{getPendingMessage(subscription?.baseSubscription)?.out_message}}">
                              info
                            </mat-icon>
                            <div class="notify-bubble"
                              [style.top]="subscription?.baseSubscription.out_status_desc=='Pending Creation'?'60px':'50px'">
                              {{getPendingMessage(subscription?.baseSubscription)?.changeAmount}}</div>
                          </td>
                          <td class="align-center">
                            <button class="button button-red button-round"
                              (click)="manageAzureSubscription(subscription?.baseSubscription)">
                              Manage
                            </button>
                          </td>
                        </tr>
                      </ng-container>
                      <ng-container *ngFor="let annuityItemPending of annuityItemsPendingList; let i = index;">
                        <tr class="top-border-light-white">
                          <td class="align-center vertical-align-mid">
                            <button class="button button-red button-mid"
                              (click)="removeAnnuityPendingItem(annuityItemPending)">Remove</button>
                          </td>
                          <td class="pending-description-col position-relative">
                            <div class="arrowright"><i class="fas fa-caret-right fa-2x"></i></div>
                            <div class="description">{{annuityItemPending?.description}}</div>
                            <div class="result-info">
                              <div class="produc-secondary-title-wrapper">
                                <span>STOCK CODE:&nbsp;</span>
                                <span class="red-bold">{{annuityItemPending?.stockCode}}</span>
                              </div>
                            </div>
                          </td>
                          <td class="align-center">
                            <input class="align-center input-wrapper input-wrapper-small" disabled type="text"
                              [value]="annuityItemPending?.quantity">
                          </td>
                          <td class="align-center">{{annuityItemPending?.itemPrice}}
                            <span *ngIf="annuityItemPending?.billingFrequency == '1'">/mth</span>
                            <span *ngIf="annuityItemPending?.billingFrequency == 'Y'">/yr</span>
                          </td>
                          <td class="align-center">
                            {{annuityItemPending?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                          <td class="align-center">&nbsp;</td>
                          <td class="align-center statustext">Pending Confirm</td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr class="pending-grey-row info-row">
                          <td></td>
                          <td><b>SUBSCRIPTION DESCRIPTION&nbsp;&nbsp;&nbsp;&nbsp;
                              <input type="text" class="input" maxlength="30"
                                [(ngModel)]="annuityItemPending.subscriptionDescription"
                                (input)="cs.subscription_customer_ref_validation($event)"></b>
                          </td>
                          <td colspan="3" class="padding-r-x0">
                            <b>MPN ID</b>
                            <mat-form-field>
                              <input type="text" id="{{annuityItemPending.stockCode}}" class="subscriptionmpn"
                                integerOnly name="matmpnid" aria-label="Number" [(ngModel)]="annuityItemPending.mpn"
                                matInput #triggerSubMpn="matAutocompleteTrigger" [matAutocomplete]="autoSub">
                              <i class="material-icons align-arrow-right"
                                (click)="showAutoCompletePanel(triggerSubMpn);$event.stopPropagation()">arrow_drop_down</i>
                              <mat-autocomplete #autoSub="matAutocomplete">
                                <mat-option [value]="NoMPNText">
                                  {{NoMPNText}}
                                </mat-option>
                                <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                                  {{mpn}}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>

                          </td>
                          <td class="padding-x0">
                            <div id="{{annuityItemPending.mpn}}"> </div>
                          </td>
                          <td colspan="3" class="padding-x0">
                            <mat-spinner *ngIf="showMpnIdloading" mode="indeterminate" class="circle"
                              diameter="20"></mat-spinner>
                          </td>
                        </tr>

                        <tr colspan="1" class="pending-grey-row info-row"
                          *ngIf="annuityItemPending?.stockGroup == '85CU'">
                          <td></td>
                          <td colspan="1" class="padding-r-x0">
                            <b>OWNER EMAIL&nbsp;&nbsp;&nbsp;&nbsp;</b>
                            <input type="text" id="{{annuityItemPending.stockCode}}email" class="input ownerEmail"
                              [(ngModel)]="annuityItemPending.ownerEmail"
                              (blur)="checkSubscriptionOwnerEmailStatus(annuityItemPending)" required>
                          </td>
                          <td colspan="6" class="padding-x0">
                            <mat-spinner *ngIf="showEmailloading" mode="indeterminate" class="circle"
                              diameter="20"></mat-spinner>
                          </td>
                        </tr>

                      </ng-container>
                    </tbody>
                    <tfoot>

                    </tfoot>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col button-center" *ngIf="purchase == 'Y'" style="margin-bottom: 20px;">
                  <button class="button button-red button-large btn-long"
                    [disabled]="isSubscriptionResponseLoading || (subscriptionResponse?.status != 'Success'  && subscriptionResponse?.status != 'MCA')"
                    (click)="getProductList('MicrosoftAzure');">
                    Add new product
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Reserved Instances -->
        <mat-expansion-panel [expanded]="panelReservedInstanceOpen" [disabled]="details?.customer?.out_status != ''"
          (opened)="RITabClick()">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">
              RESERVED INSTANCE
            </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text" *ngIf="cspReservedInstanceItems?.length"> {{
                cspReservedInstanceItems?.length?cspReservedInstanceItems?.length:"0" }} Reserved Instance(s) </span>
              <mat-spinner *ngIf="!loadCSPAzureri" mode="indeterminate" class="circle cSPCustomerEntitlements-loading"
                diameter="20">
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div role="tabpanel" aria-labelledby="headingAzureri">
            <mat-spinner *ngIf="!loadCSPAzureri" mode="indeterminate" class="circle" style="margin: 15px auto;"
              diameter="20">
            </mat-spinner>
            <div class="panel-body">
              <div *ngIf="(!cspReservedInstanceItems?.length&&!azureRIItemsPendingList?.length) && loadCSPAzureri">
                <div class="noData-wrapper">
                  <label class="noData-label">
                    We couldn't find any Azure reserved instance for this tenant
                  </label>
                  <br />
                  <button class="button button-red button-large btn-long" (click)="getProductList('Reservations');">Add
                    new product</button>

                </div>
              </div>

              <div *ngIf="(cspReservedInstanceItems?.length||azureRIItemsPendingList?.length) && loadCSPAzureri">
                <div class="mTable">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 5%;"></th>
                        <th scope="col" style="width: 20%;">STOCK CODE</th>
                        <th scope="col" style="width: 35%;">STOCK DESCRIPTION</th>
                        <th scope="col" class="align-center" style="width: 20%;">EXPIRY DATE</th>
                        <th scope="col" class="align-center" style="width: 10%;">QTY</th>
                        <th scope="col" class="align-center" style="width: 10%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let lineItem of cspReservedInstanceItems; let idx = index;">
                        <td class="align-center align-top">
                          &nbsp;
                        </td>
                        <td class="align-left push-right">
                          {{lineItem?.stockCode}}
                        </td>
                        <td>
                          <span class="align-left">{{lineItem?.description}}</span>
                        </td>
                        <td class="align-center align-top">
                          {{lineItem?.expiryDate}}
                        </td>
                        <td class="align-center align-top">
                          {{lineItem?.quantity}}
                        </td>
                        <td class="align-center align-top">
                          <!-- <button
                            [disabled]="checkingAzureRIIndex == idx"
                            (click)="manageAzureRI(lineItem, idx)"
                            class="button button-red button-mid addonbtn"
                          >Manage</button> -->
                        </td>
                      </tr>
                      <ng-container *ngFor="let pendingItem of azureRIItemsPendingList">
                        <tr>
                          <td class="align-center align-top">
                            &nbsp;
                          </td>
                          <td class="align-left push-right">
                            {{pendingItem?.stockCode}}
                          </td>
                          <td>
                            <span class="description">{{pendingItem?.description}}</span>
                          </td>
                          <td class="align-center align-top">
                            &nbsp;
                          </td>
                          <td class="align-center align-top">
                            {{pendingItem?.quantity}}
                          </td>
                          <td class="align-center align-top">
                            <button class="button button-red button-mid"
                              (click)="removeAzureRIItemsPending(pendingItem)">
                              Remove</button>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                  <div class="col align-center confirmbtn">
                    <button class="button button-red button-large btn-long"
                      (click)="getProductList('Reservations');">Add new product</button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Software -->
        <mat-expansion-panel [expanded]="panelSoftwareOpen" [disabled]="details?.customer?.out_status != ''"
          (opened)="softwareTabClick()">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">
              SOFTWARE
            </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text" *ngIf="cspSoftwareItems?.length"> {{
                cspSoftwareItems?.length?cspSoftwareItems?.length:"0" }} Software(s) </span>
              <mat-spinner *ngIf="loadCSPSoftware==false || checkingSoftwareSubscriptionIndex > -1" mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading" diameter="20">
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div role="tabpanel" aria-labelledby="headingSoftware">
            <mat-spinner *ngIf="!loadCSPSoftware" mode="indeterminate" class="circle" style="margin: 15px auto;"
              diameter="20">
            </mat-spinner>
            <div class="panel-body">
              <div *ngIf="(!cspSoftwareItems?.length&&!softwareSubscriptionPendingList.length) && loadCSPSoftware">
                <div class="noData-wrapper">
                  <label class="noData-label">
                    We couldn't find any software subscription for this tenant
                  </label>
                  <br />
                  <button class="button button-red button-large btn-long" (click)="getProductList('Software');">Add new
                    product</button>
                </div>
              </div>
              <div *ngIf="(cspSoftwareItems?.length||softwareSubscriptionPendingList?.length) && loadCSPSoftware">
                <div class="mTable">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 5%;"></th>
                        <th scope="col" style="width: 20%;">STOCK CODE</th>
                        <th scope="col" style="width: 35%;">STOCK DESCRIPTION</th>
                        <th scope="col" class="align-center" style="width: 20%;">EXPIRY DATE</th>
                        <th scope="col" class="align-center" style="width: 10%;">QTY</th>
                        <th scope="col" class="align-center" style="width: 10%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let lineItem of cspSoftwareItems; let idx = index;">
                        <td class="align-center align-top">
                          &nbsp;
                        </td>
                        <td class="align-left push-right">
                          {{lineItem?.stockCode}}
                        </td>
                        <td>
                          <span class="align-left">{{lineItem?.description}}</span>
                        </td>
                        <td class="align-center align-top">
                          {{lineItem?.expiryDate}}
                        </td>
                        <td class="align-center align-top">
                          {{lineItem?.quantity}}
                        </td>
                        <td class="align-center align-top">
                          <button class="button button-red button-mid addonbtn mt-3"
                            *ngIf="lineItem?.stockGroup == '85SS'" [disabled]="checkingSoftwareSubscriptionIndex == idx"
                            (click)="manageSoftware(lineItem,idx)">Manage</button>
                        </td>
                      </tr>
                      <tr *ngFor="let pendingItem of softwareSubscriptionPendingList">
                        <td class="align-center align-top">
                          &nbsp;
                        </td>
                        <td class="align-left push-right">
                          {{pendingItem?.stockCode}}
                        </td>
                        <td>
                          <span class="description">{{pendingItem?.description}}</span>
                        </td>
                        <td class="align-center align-top">
                          &nbsp;
                        </td>
                        <td class="align-center align-top">
                          {{pendingItem?.quantity}}
                        </td>
                        <td class="align-center align-top">
                          <button class="button button-red button-mid"
                            (click)="removeSoftwareSubscriptionPendingList(pendingItem)">Remove</button>
                        </td>

                      </tr>
                    </tbody>
                  </table>
                  <div class="col align-center confirmbtn" *ngIf="purchase == 'Y'">
                    <button class="button button-red button-large btn-long" (click)="getProductList('Software');">
                      Add new product
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Order History -->
        <mat-expansion-panel [expanded]="panelSoftwareOpen" [disabled]="details?.customer?.out_status != ''"
          (opened)="orderHistoryTabClick()">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">
              ORDER HISTORY
            </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <mat-spinner *ngIf="orderHistoryLoading" mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading" diameter="20">
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="font-size: 12px;">
            <div class="panel-body">
              <div *ngIf="orderHistory?.length">
               <!--  <div class="mTable-header"> -->
                  <div class="row filter-wrapper">
                    <div class="col-md-3" style="padding-bottom: 1.25em;">
                      <div class="searchInputGroup">
                        <div class="searchIcon">
                          <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" placeholder="Filter"
                          (keyup)="applyOrderHistoryFilter($event)">
                      </div>
                    </div>
                    <div class="col-md-1"></div>
                  </div>
                <!-- </div> -->
                <div class="mTable">
                  <div *ngIf="orderHistory?.length" style="max-height: 500px; overflow-y: scroll;">
                    <table class="table" mat-table [dataSource]="orderHistoryTableDataSource"
                      style="margin-bottom: unset;">
                      <!-- Order Date Column -->
                      <ng-container matColumnDef="orderDate">
                        <th mat-header-cell *matHeaderCellDef class="table-cell" style = "vertical-align: middle;">ORDER DATE</th>
                        <td class="push-left-75 table-cell" mat-cell *matCellDef="let pt">
                          <div class="description">
                            <span>{{ pt?.creationDate | date: 'dd/MM/yyyy h:mm a' }}</span>
                          </div>
                        </td>
                      </ng-container>

                      <!-- Order Type Column -->
                      <ng-container matColumnDef="orderType">
                        <th mat-header-cell *matHeaderCellDef class="table-cell"
                          style="text-align: left; white-space: nowrap;vertical-align: middle;">
                          ORDER TYPE
                        </th>
                        <td mat-cell *matCellDef="let pt;" style="text-align: left;" class="align-top table-cell">
                          <span> {{ pt?.orderType }} </span>
                        </td>
                      </ng-container>

                      <!-- Stock Code Column -->
                      <ng-container matColumnDef="stockCode">
                        <th mat-header-cell *matHeaderCellDef class="table-cell"
                          style="text-align: left; white-space: nowrap;vertical-align: middle;">
                          STOCK CODE
                        </th>
                        <td mat-cell *matCellDef="let pt;" style="text-align: left;" class="align-top table-cell">
                          <span> {{ pt?.offerId }} </span>
                        </td>
                      </ng-container>

                      <!-- Stock Description Column -->
                      <ng-container matColumnDef="stockDescription">
                        <th *matHeaderCellDef mat-header-cell class="table-cell" style="text-align: left;vertical-align: middle;">
                          STOCK DESCRIPTION
                        </th>
                        <td mat-cell *matCellDef="let pt;" class="align-top table-cell" style="text-align: left;">
                          <span> {{ pt?.stockDescription }} </span>
                        </td>
                      </ng-container>

                      <!-- Qty Column -->
                      <ng-container matColumnDef="qty">
                        <th *matHeaderCellDef mat-header-cell class="table-cell" style="text-align: left;vertical-align: middle;">
                          QTY
                        </th>
                        <td mat-cell *matCellDef="let pt;" class="align-top table-cell" style="text-align: center;">
                          <span> {{ pt?.quantity }} </span>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="orderHistoryDisplayedColumns;sticky:true"></tr>
                      <tr mat-row *matRowDef="let row; columns: orderHistoryDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<!-- popup for the upgrade the azure button -->
<ng-template #upgradeAzureContainer let-c="close" let-d="dismiss">
  <div class="shopping-cart-modal shopping-cart-size">
    <child-header title="Upgrade to Azure Plan" (closeEvent)="d('Cross click')"></child-header>
    <div style="padding-top: 10px;" class="modal-body">
      <p>
        Are you sure you want to upgrade this tenant to Azure Plan? This process will take a few minutes to complete,
        during which time there will be no impact to your subscription or resources. This process can not be reversed.
      </p>
      <div class="button-center">
        <button class="button button-red button-mid button-center-left"
          [class.showAzureButtonMargin]="!showAzureButtonloading" (click)="upgradeAzurePlan()">Yes</button>
        <div colspan="4" *ngIf="showAzureButtonloading" class="azure-loading">
          <mat-spinner mode="indeterminate" class="circle" diameter="20"></mat-spinner>
        </div>
        <button class="button button-red button-mid button-center-right" (click)="d('Cross click')">No</button>
      </div>
    </div>
  </div>
</ng-template>
<router-outlet></router-outlet>